// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--2oNDQ","content":"Card-module--content--1s_Fz","heading":"Card-module--heading--3yCWe"};